import "../styles/latestBuzz.css"
function BuzzListItem({ item }) {
    return (
      <a
        href={item.youtubeUrl}
        target="_blank"
        rel="noreferrer"
        className="buzz-card"
      >
        <div className="buzz-thumb-wrapper">
          <img
            src={item.thumbnail}
            alt={item.title}
            className="buzz-thumb"
            onError={(e) => (e.target.style.display = "none")}
          />
  
          {/* ▶ Play Overlay */}
          <div className="play-overlay">▶</div>
        </div>
  
        <p className="buzz-title">{item.title}</p> 
      </a>
    );
  }
  
  export default BuzzListItem;
  